import callApi from '../../util/apiCaller.js';
import { addError } from '../Error/ErrorActions.js';

export const SOCIAL_PLATFORMS = [
    { key: 'facebook', labelId: 'influenceurSocialFacebook', defaultMessage: 'Facebook' },
    { key: 'instagram', labelId: 'influenceurSocialInstagram', defaultMessage: 'Instagram' },
    { key: 'youtube', labelId: 'influenceurSocialYoutube', defaultMessage: 'YouTube' },
    { key: 'tiktok', labelId: 'influenceurSocialTikTok', defaultMessage: 'TikTok' },
    { key: 'blog', labelId: 'influenceurSocialBlog', defaultMessage: 'Blog' },
    { key: 'other', labelId: 'influenceurSocialOther', defaultMessage: 'Other' },
];

export const SET_PARTNERS = 'SET_PARTNERS';
export const REMOVE_PARTNER = 'REMOVE_PARTNER';

// Actions
export function getPartnersRequest(filters = {}) {
    return dispatch => {
        return callApi('partners', 'get', { filters }).then(res => {
            res.partners && dispatch(setPartners(res.partners));
            return res.partners;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getPartnerRequest(idOrUser) {
    return dispatch => {
        return callApi(`partner/${idOrUser}`).then(res => {
            res.partner && dispatch(setPartners([res.partner]));
            return res.partner;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editPartnerRequest(partner) {
    return dispatch => {
        return callApi('partner/edit', 'post', { partner }).then(res => {
            res.partner && dispatch(setPartners([res.partner]));
            return res.partner;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function removePartnerRequest(partnerId) {
    return dispatch => {
        return callApi('partner/remove', 'delete', { partner: { _id: partnerId } }).then(res => {
            dispatch({ type: REMOVE_PARTNER, partnerId });
            return res;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function registerPartnerRequest(partner) {
    return dispatch => {
        return callApi('partner/register', 'post', { partner }).then(res => {
            return res.partner;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// Selectors
export function getPartners(store) {
    return (store.partners || {}).data || [];
}

// Reducers actions
function setPartners(partners) {
    return { type: SET_PARTNERS, partners };
}
